export const DEFAULT_LIVE_PROFILE: LiveProfile = {
  title: '我的直播间',
  avatarUrl: null,
  revision: 0,
};

export type LiveProfile = {
  title: string;
  avatarUrl: string | null;
  revision: number;
};

export function normalizeLiveTitle(value: unknown, fallback = DEFAULT_LIVE_PROFILE.title) {
  if (typeof value !== 'string') return fallback;
  const title = Array.from(
    value
      .normalize('NFKC')
      .replace(/[\u0000-\u001f\u007f]/g, '')
      .trim(),
  )
    .slice(0, 32)
    .join('');
  return title || fallback;
}

export function parseLiveProfile(value: unknown, fallback = DEFAULT_LIVE_PROFILE): LiveProfile {
  if (!value || typeof value !== 'object') return fallback;
  const input = value as Partial<LiveProfile>;
  const avatarUrl =
    typeof input.avatarUrl === 'string' && input.avatarUrl.startsWith('/api/live/profile/avatar?')
      ? input.avatarUrl.slice(0, 256)
      : null;
  return {
    title: normalizeLiveTitle(input.title, fallback.title),
    avatarUrl,
    revision:
      typeof input.revision === 'number' && Number.isSafeInteger(input.revision)
        ? input.revision
        : fallback.revision,
  };
}

export function parseLiveProfileMetadata(metadata?: string, fallback = DEFAULT_LIVE_PROFILE) {
  if (!metadata) return fallback;
  try {
    return parseLiveProfile(JSON.parse(metadata), fallback);
  } catch {
    return fallback;
  }
}
